var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "97854E72-A3C3-443B-B166-CB96B85150A7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Invoices",
    transform: "translate(-796.000000, -888.000000)",
    fill: "#A1A5B3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(0.000000, 856.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(470.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Phone",
    transform: "translate(326.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Phone_56382_000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8359111,13.4433778 C14.9296,15.6161778 12.8046222,15.9969778 12.1102222,15.9969778 C11.9063111,15.9969778 8.73066667,16.1653333 4.16568889,11.8352 C0.491911111,8.3504 0.0430222222,4.60302222 0.00391111111,3.89102222 C-0.0341333333,3.19751111 0.164444444,1.45777778 2.55768889,0.165155556 C2.85422222,0.00497777778 3.44213333,-0.0659555556 3.59395556,0.0858666667 C3.66133333,0.153244444 5.67004444,3.45866667 5.72284444,3.56817778 C5.77564444,3.67751111 5.80213333,3.78524444 5.80213333,3.89084444 C5.80213333,4.04177778 5.69457778,4.23057778 5.47928889,4.45706667 C5.26417778,4.68355556 5.03022222,4.8912 4.77724444,5.07982222 C4.52426667,5.26862222 4.29031111,5.46862222 4.07502222,5.68 C3.85991111,5.8912 3.75235556,6.06506667 3.75235556,6.20088889 C3.76693333,6.55342222 4.05582222,7.81617778 6.25653333,9.74986667 C8.4576,11.6840889 9.51786667,12.2289778 9.61973333,12.2666667 C9.72177778,12.3043556 9.80657778,12.3230222 9.87448889,12.3230222 C10.0104889,12.3230222 10.1841778,12.2156444 10.3955556,12.0005333 C10.6067556,11.7852444 11.3173333,10.8113778 11.5438222,10.5960889 C11.7703111,10.3811556 11.9591111,10.2736 12.1102222,10.2736 C12.2158222,10.2736 12.3233778,10.2999111 12.4327111,10.3527111 C12.5422222,10.4055111 15.8519111,12.3422222 15.9152,12.4069333 C16.0869333,12.5829333 15.9656889,13.1322667 15.8359111,13.4433778",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.621f8a8e53b3ccf1ab3b9cbc415f4899.svg";
export { ForwardRef as ReactComponent };